import React from 'react';
import LegalLayout from './LegalLayout';
import { WHATSAPP_CONTACT_URL } from '../landing/content';

// ATENÇÃO: texto-base sujeito a revisão jurídica. Trechos entre colchetes são
// placeholders a serem preenchidos com os dados reais da empresa.
const SECTIONS = [
  {
    id: 'aceite',
    title: 'Aceite dos termos',
    blocks: [
      'Estes Termos de Uso regulam o acesso e a utilização do FlowVendas, sistema de gestão (ERP) em nuvem oferecido por [RAZÃO SOCIAL], inscrita no CNPJ sob o nº [CNPJ], com sede em [ENDEREÇO] ("FlowVendas").',
      'Ao criar uma conta e marcar a opção "Li e concordo com os Termos de Uso e a Política de Privacidade", ou ao utilizar o sistema, você declara que leu, compreendeu e concorda com estes Termos e com a Política de Privacidade.',
    ],
  },
  {
    id: 'servico',
    title: 'Descrição do serviço',
    blocks: [
      'O FlowVendas é um software fornecido como serviço (SaaS), acessado pela internet, voltado a estabelecimentos que vendem produtos e prestam serviços. Entre as funcionalidades disponibilizadas estão:',
      { list: [
        'vendas e frente de caixa, caixa e transações financeiras;',
        'cadastro de produtos, categorias, estoque e fornecedores;',
        'cadastro de clientes e veículos, ordens de serviço, orçamentos e checklists;',
        'relatórios e painéis de acompanhamento;',
        'assistente de inteligência artificial para consulta de informações do seu próprio sistema;',
        'envio de documentos e avisos a clientes por WhatsApp, quando configurado pelo usuário.',
      ] },
      'As funcionalidades disponíveis podem variar conforme o plano contratado e podem ser alteradas, aprimoradas ou descontinuadas ao longo do tempo.',
    ],
  },
  {
    id: 'cadastro',
    title: 'Cadastro e conta',
    blocks: [
      'Para utilizar o sistema é necessário criar uma conta, informando nome do estabelecimento, segmento, nome, sobrenome, e-mail, celular e senha. Você se compromete a fornecer informações verdadeiras, completas e atualizadas.',
      'Cada estabelecimento possui um ambiente próprio, e o titular da conta pode cadastrar outros usuários e definir seus perfis de acesso. Você é responsável por manter a confidencialidade das credenciais, por todas as atividades realizadas com elas e por comunicar imediatamente qualquer uso não autorizado.',
      'A contratação é destinada a pessoas maiores de 18 anos ou a pessoas jurídicas devidamente representadas.',
    ],
  },
  {
    id: 'teste-gratis',
    title: 'Teste grátis e planos',
    blocks: [
      'O FlowVendas pode oferecer um período de teste grátis de 14 dias, sem necessidade de cartão de crédito, conforme divulgado no momento do cadastro. Ao término do período de teste, a continuidade do uso depende da contratação de um plano.',
      'Valores, formas de pagamento, periodicidade e condições de cancelamento dos planos são os informados no momento da contratação. Condições específicas: [CONDIÇÕES DE COBRANÇA E CANCELAMENTO].',
    ],
  },
  {
    id: 'uso-adequado',
    title: 'Uso adequado',
    blocks: [
      'Você se compromete a utilizar o sistema de acordo com a lei e com estes Termos. É vedado:',
      { list: [
        'utilizar o sistema para fins ilícitos, fraudulentos ou que violem direitos de terceiros;',
        'tentar acessar dados de outros estabelecimentos ou burlar mecanismos de segurança e de isolamento entre contas;',
        'realizar engenharia reversa, copiar, revender ou sublicenciar o software sem autorização;',
        'sobrecarregar a infraestrutura ou introduzir códigos maliciosos;',
        'cadastrar dados de terceiros sem possuir base legal para isso.',
      ] },
    ],
  },
  {
    id: 'dados-do-cliente',
    title: 'Dados inseridos pelo usuário',
    blocks: [
      'Os dados que você insere no sistema (como clientes, veículos, produtos, vendas e ordens de serviço) permanecem de sua titularidade. Em relação aos dados pessoais de seus clientes finais, o estabelecimento atua como controlador e o FlowVendas atua como operador, tratando-os conforme suas instruções e a Política de Privacidade.',
      'Você é responsável pela licitude dos dados inseridos e por obter, quando necessário, o consentimento ou outra base legal para o tratamento, inclusive para o envio de mensagens por WhatsApp a seus clientes.',
    ],
  },
  {
    id: 'ia-whatsapp',
    title: 'Assistente de IA e integração com WhatsApp',
    blocks: [
      'O assistente de inteligência artificial responde a perguntas em linguagem natural com base nas informações do seu sistema e tem finalidade de consulta. As respostas são geradas automaticamente, podem conter imprecisões e devem ser conferidas antes de embasar decisões.',
      'A integração com WhatsApp permite enviar ordens de serviço, orçamentos e lembretes a seus clientes. O conteúdo e a frequência das mensagens são de responsabilidade do usuário, que deve respeitar a legislação aplicável e as políticas do WhatsApp.',
    ],
  },
  {
    id: 'propriedade-intelectual',
    title: 'Propriedade intelectual',
    blocks: [
      'O software, a marca FlowVendas, o layout e demais elementos do sistema são protegidos por direitos de propriedade intelectual e pertencem a [RAZÃO SOCIAL] ou a seus licenciantes. A contratação concede apenas uma licença limitada, revogável, não exclusiva e intransferível de uso, durante a vigência do contrato.',
    ],
  },
  {
    id: 'disponibilidade',
    title: 'Disponibilidade e suporte',
    blocks: [
      'O FlowVendas empenha-se em manter o sistema disponível, mas não garante funcionamento ininterrupto ou livre de erros. Podem ocorrer interrupções para manutenção, atualizações ou por motivos fora do nosso controle.',
      'Em caso de dúvidas ou necessidade de suporte, utilize os canais indicados na seção de contato.',
    ],
  },
  {
    id: 'responsabilidade',
    title: 'Limitação de responsabilidade',
    blocks: [
      'Na extensão permitida pela lei, o FlowVendas não se responsabiliza por danos indiretos, lucros cessantes ou perdas decorrentes de uso indevido do sistema, de informações incorretas inseridas pelo usuário, de falhas de internet ou de serviços de terceiros, nem por decisões tomadas com base em respostas do assistente de IA ou em relatórios do sistema.',
      'Nada nestes Termos exclui responsabilidades que não possam ser limitadas por lei, inclusive as previstas no Código de Defesa do Consumidor, quando aplicável.',
    ],
  },
  {
    id: 'suspensao',
    title: 'Suspensão e encerramento',
    blocks: [
      'Você pode cancelar sua conta a qualquer momento. O FlowVendas pode suspender ou encerrar o acesso em caso de descumprimento destes Termos, uso fraudulento ou inadimplência, observadas as condições do plano contratado.',
      'Após o encerramento, o tratamento e a eventual exclusão dos dados seguem a Política de Privacidade.',
    ],
  },
  {
    id: 'alteracoes',
    title: 'Alterações destes Termos',
    blocks: [
      'Estes Termos podem ser atualizados periodicamente. A data da última atualização é informada no início desta página. O uso continuado do sistema após a atualização indica a concordância com a nova versão.',
    ],
  },
  {
    id: 'contato-foro',
    title: 'Contato e foro',
    blocks: [
      'Para dúvidas sobre estes Termos, entre em contato pelo e-mail [E-MAIL DE CONTATO] ou pelo nosso canal de atendimento no WhatsApp.',
      'Fica eleito o foro da comarca de [FORO] para dirimir eventuais controvérsias, ressalvadas as hipóteses em que a lei estabeleça foro diverso, como nas relações de consumo.',
      { link: { label: 'Falar pelo WhatsApp', href: WHATSAPP_CONTACT_URL } },
    ],
  },
];

export default function TermsOfUse() {
  return (
    <LegalLayout
      title="Termos de Uso"
      intro="Leia com atenção as condições para utilização do FlowVendas."
      sections={SECTIONS}
    />
  );
}
